import type { BindingCtx, DomainRead } from "../../../../state/editor/types";
import { useUi } from "../../../../state/editor/useEditor";
import { MiniBtn } from "../../inspector/rows";
import { MaterialCategoryGrid } from "../../library/MaterialCategoryGrid";

/**
 * Material library (checklist title: "Material Library").
 *
 * The swatch grid used to live here AND on the left rail — the reference ships
 * both, and we copied that. Two grids over one set of presets is the thing that
 * made this editor feel cluttered, so the grid now lives in one place: the
 * left rail, where a part is picked and where there is room for 144 tiles.
 *
 * ⚠️ The SECTION stays. `"Material Library"` is one of the 69 titles
 * `scripts/check-ijewel-parity.mjs` matches by exact string equality, so
 * deleting it fails the parity guard. What stays here is the half that exists
 * nowhere else: per-selection `.pmat` / `.dmat` import and export.
 */
export function MaterialLibrary({ ctx }: { ctx: BindingCtx; read: DomainRead }) {
  const [, patchUi] = useUi();
  const selected = !!ctx.selectionId;
  // One calm line and one button, not an arrow glyph and three bold words
  // wrapping across a 300px column.
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 rounded-lg bg-ed-panel-2 px-2.5 py-2">
        <p className="min-w-0 flex-1 text-[12px] leading-[1.4] text-ed-text-2">
          {selected
            ? "Metals, gems and other finishes for this part are in the library on the left."
            : "Select a part in the view, then pick its material from the library on the left."}
        </p>
        {selected ? (
          <MiniBtn icon="texture" onClick={() => patchUi({ leftPanel: "metals", lastAdvancedLeftPanel: "metals" })}>
            Open
          </MiniBtn>
        ) : null}
      </div>
      {/* File I/O only: no category tabs, no grid, no second copy of the
          apply pipeline. */}
      <MaterialCategoryGrid categories={[]} showFileIO />
    </div>
  );
}
